export const SET_IMPORT_CARDS = "SET_IMPORT_CARDS";
export const SET_IMPORT_TRANSACTIONS = "SET_IMPORT_TRANSACTIONS";
export const SET_IMPORT_DELETE_TRANSACTIONS = "SET_IMPORT_DELETE_TRANSACTIONS";
export const SET_UPLOAD_FILE = "SET_UPLOAD_FILE";
export const GET_FILES = "GET_FILES";
export const GET_FILTER_TYPES = "GET_FILTER_TYPES";
export const SET_FILTER_TYPES = "SET_FILTER_TYPES";
const SET_FILES = "SET_FILES";

export const setUploadFile = (selectedFile: any) => ({
  type: SET_UPLOAD_FILE,
  selectedFile,
});

export const setFilterTypes = (filterTypes: any) => ({
  type: SET_FILTER_TYPES,
  filterTypes,
});

export const setAvailableFiles = (availableFiles: any) => ({
  type: SET_FILES,
  availableFiles,
});

const initialState = {};

export const fileImportReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_FILTER_TYPES:
      const { filterTypes } = action;
      return { ...state, filterTypes: filterTypes };
    case SET_UPLOAD_FILE:
      const { selectedFile } = action;
      return { ...state, selectedFile: selectedFile };
    case SET_FILES:
      const { availableFiles } = action;
      return { ...state, availableFiles: availableFiles };
    default:
      return state;
  }
};
